import { useMemo } from 'react';

import { useTranslation } from '../../../../hooks/useTranslation';
import { CastType } from '../../../../types';
import { doesSearchMatchCastType } from './doesSearchMatchCastType';

type UseCastTypeOptionsProps = {
  search: string;
};

export const useCastTypeOptions = ({ search }: UseCastTypeOptionsProps) => {
  const { t } = useTranslation();
  return useMemo(
    () =>
      Object.values(CastType)
        .map((castType) => ({
          title: t(`v2.conditionBuilder.longCastType.${castType}`),
          value: castType,
        }))
        .sort(({ title: a }, { title: b }) => a.localeCompare(b))
        .filter((option) => doesSearchMatchCastType(option.title, search)),
    [t, search],
  );
};
